const localStorageService = {
    // Set item in localStorage with optional expiration (in hours)
    set(key, value, expirationInHours = null) {
        const data = {
            value: typeof value === 'object' ? JSON.stringify(value) : value,
            expiration: expirationInHours ? Date.now() + expirationInHours * 60 * 60 * 1000 : null
        };
        localStorage.setItem(key, JSON.stringify(data));
    },

    // Get item from localStorage
    get(key) {
        const rawData = localStorage.getItem(key);
        if (!rawData) return null;

        try {
            if (!rawData.startsWith('{') && !rawData.startsWith('[')) {
                return rawData;
            }

            const data = JSON.parse(rawData);
            // If there's an expiration and it's expired, remove the item and return null
            if (data.expiration && Date.now() > data.expiration) {
                this.remove(key);
                return null;
            }
            return typeof data.value === 'string' && this.isJSON(data.value) 
                ? JSON.parse(data.value) 
                : data.value;
        } catch (e) {
            console.error("Error parsing localStorage data:", e);
            return null;
        }
    },

    // Remove item from localStorage
    remove(key) {
        localStorage.removeItem(key);
    },

    // Clear all items in localStorage
    clear() {
        localStorage.clear();
    },

    // Check if a key exists in localStorage
    exists(key) {
        return this.get(key) !== null; // Automatically checks expiration
    },

    // Utility to check if a string is JSON
    isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch {
            return false;
        }
    }
};

export default localStorageService;
